import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {HomeRepository} from '../repositories/home.repository';
import { ActivityLog } from 'shared/classes/activityLog';

@Injectable()
export class HomeService {

  constructor(private homeRepository: HomeRepository) { }

  public getActivityAll(from: string, to: string): Observable<Array<any>> {
    return this.homeRepository.getActivityAll(from, to);
  }

  public getAnswerActivityAll(systemName: string, from: string, to: string): Observable<Array<any>> {
    return this.homeRepository.getAnswerActivityAll(systemName, from, to);
  }

  public getActivityByCompany(from: string, to: string): Observable<Array<any>> {
    return this.homeRepository.getActivityByCompany(from, to);
  }

  public getAnswerActivityByCompany(systemName: string, from: string, to: string): Observable<Array<any>> {
    return this.homeRepository.getAnswerActivityByCompany(systemName, from, to);
  }

  public getThesisActivityByCompany(from: string, to: string): Observable<Dictionary<Array<ActivityLog>>> {
    return this.homeRepository.getThesisActivityByCompany(from, to);
  }

  public getDialogAnswerActivityByCompany(from: string, to: string): Observable<Array<any>> {
    return this.homeRepository.getDialogAnswerActivityByCompany(from, to);
  }

  public getUsersCreated(): Observable<Array<any>> {
    return this.homeRepository.getUsersCreated();
  }

  public getUsersFirstUsed(): Observable<Array<any>> {
    return this.homeRepository.getUsersFirstUsed();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/home/services/home.service.ts